import { pluralTitleRegExp } from '@v2/pages/common/constants/base.constants';
import { useGetHeaderConfig } from './useGetHeaderConfig';

export const useHeaderConfigPluralCheck = () => {
  const headerConfig = useGetHeaderConfig();

  const batchPlural = headerConfig?.batch ? pluralTitleRegExp.test(headerConfig?.batch) : false;

  const ncFilePlural = headerConfig?.ncFile ? pluralTitleRegExp.test(headerConfig?.ncFile) : false;

  const partPlural = headerConfig?.part?.name ? pluralTitleRegExp.test(headerConfig?.part?.name) : false;

  const jobsPlural = headerConfig?.job ? pluralTitleRegExp.test(headerConfig?.job) : false;

  const toolsPlural = headerConfig?.tools ? pluralTitleRegExp.test(headerConfig?.tools) : false;

  const productionOrdersPlural = headerConfig?.productionOrder ? pluralTitleRegExp.test(headerConfig?.productionOrder) : false;

  return { batchPlural, ncFilePlural, partPlural, jobsPlural, toolsPlural, productionOrdersPlural };
};
